// 广告集合
import { connect } from 'react-redux'
import React, { Fragment } from 'react';
import './recommend-ads.scss';

class RecommendAds  extends React.Component {
  
  render() {
    return (
      <Fragment>
        <PopupAd ads = {this.props.__BASE.toJS().ads} />
        <CoupletAd ads = {this.props.__BASE.toJS().ads}/>
      </Fragment>
    );
  }
}

function mapStateToProps(state) {
  return {
    __BASE: state.base
  }
}

export default connect(
  mapStateToProps
)(RecommendAds)


// 弹出广告
class PopupAd  extends React.Component {
  constructor(props) {
    super(props);
    this.state ={
      display:true
    }
  }

  render() {

    const ads = _.filter(this.props.ads, (item) => item.type == 'popup');
    
    if(!this.state.display || ads.length === 0){
      return (<div></div>)
    }

    return (
      <div className='popup'>
        <i onClick={() => this.setState({display:false})}>x</i>
        <img src={ads[0].image} alt={ads[0].title} onClick={() => window.open(ads[0].forward.url)} />
      </div>
    );
  }
}

// 对联广告
class CoupletAd  extends React.Component {
  constructor(props) {
    super(props);
    this.state ={
      displayLeft:true,
      displayRight:true
    }
  }

  render() {

    const ads = _.filter(this.props.ads, (item) => item.type == 'couplet');

    return (
      <Fragment>
        {
          ads[0] && this.state.displayLeft &&
          <div className='couplet left'>
            <i onClick={() => this.setState({displayLeft:false})}>x</i>
            <img src={ads[0].image} alt={ads[0].title} onClick={() => window.open(ads[0].forward.url)} />
          </div>
        }
        {
          ads[1] && this.state.displayRight &&
          <div className='couplet right'>
            <i onClick={() => this.setState({displayRight:false})}>x</i>
            <img src={ads[1].image} alt={ads[1].title} onClick={() => window.open(ads[1].forward.url)} />
          </div>
        }
      </Fragment>
    );
  }
}